import React from 'react'
import SideQSub from './SideQSubT'
import '../../Questions.css'

export default function TenthPhysics() {
    return (
        <>
            <SideQSub />
            <div className="q-banner"></div>

            <div className="pdf-container">


                <div className="pdf-content">

                    <h1 className="pdf-title">Chapter Wise PDFs</h1>
                    <ol>
                        <li className="pdf-list"> <span className='float-l'>Ch-10 Light: Refraction and Rarefraction</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics%2FChapter%20%2D%2010%20Light%5FReflection%5Fand%5FRefraction%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-11 Human Eye and The Colourful World</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics%2FChapter%20%2D%2011%20The%5FHuman%5FEye%5Fand%5FThe%5FColourful%5FWorld%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-12 Electricity</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics%2FChapter%20%2D%2012%20Electricity%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-13 Magnetic Effects of Electric Current</span>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics%2FChapter%20%2D%2013%20Magnetic%5FEffects%5Fof%5FElectric%5FCurrent%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <span className='float-l'>Ch-14 Sources of Energy</span>
                          
                                <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics%2FChapter%20%2D%2014%20Sources%5Fof%5FEnergy%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FPhysics"> <span className="float-r"><button type="button" class="btn">
                                    <strong>VIEW</strong>
                                    <div id="container-stars">
                                        <div id="stars"></div>
                                    </div>

                                    <div id="glow">
                                        <div class="circle"></div>
                                        <div class="circle"></div>
                                    </div></button>
                                </span></a>
                            </li>
                                <hr />
                            </ol>
                        </div>





                </div>
            </>

            )
}
